import { MaterialQuantityUnit } from "src/store/api/generatedApi";
import { MixViewAs } from "../types";

export const unitForMixView = (mixView: MixViewAs): MaterialQuantityUnit => {
  switch (mixView) {
    case "mass":
      return "mass";
    case "lifts":
      return "grab";
    case "liftRecipe":
      return "ratio";
  }
};
